module.exports = __webpack_public_path__ + "img/Basque Country.8530cf6a.svg";